import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height, styles }: SvgIconProps) => {
  return (
    <img src={`/img/svg/${src}`} alt={src} width={width} height={height} style={styles} />
  )
}
